import { useMediaQuery } from "./use-media-query";

export const INTERACTIVE_PRODUCTS_BREAKPOINT = 992;

export const APP_BREAKPOINTS = Object.freeze({
	MOBILE: "MOBILE",
	DESKTOP: "NORMAL",
});

export const useAppBreakpoints = () => {
	const isSmallDevice = useMediaQuery(
		`(max-width: ${INTERACTIVE_PRODUCTS_BREAKPOINT}px)`
	);

	return {
		mode: isSmallDevice ? APP_BREAKPOINTS.MOBILE : APP_BREAKPOINTS.DESKTOP,
	};
};
